<p-card header="No access">
	<div class="card-content">
		<div>You are not authorized to access this feature.</div>
		<p-button label="Home" routerLink="/"></p-button>
	</div>
</p-card>
